import axios from 'axios';
import qs from 'qs';
import cookie from '../../cookieHelper/cookie';

const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/bulk/storyAdd';

export default function bulkStoryPublishDraft(data) {
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/json', // Adjust based on your API requirements
        },
    };

    // console.log("1: ", data);
    // console.log("2: ", qs.stringify(data));

    return (
        axios.post(API_URL, data, config)
            .then(res => {
                // console.log("res: ", res);
                return res.data;
            })
            .catch(err => {
                // console.log("err: ", err);
                return err;
            })
    );
}
